// extracted by mini-css-extract-plugin
export default {"header":"Sidebar_header__BAPAo","avatar":"Sidebar_avatar__bh3Qt","selector":"Sidebar_selector__d6gxQ"};